import { SnapshotBarCompareCard } from '@/components/snapshot/SnapshotBarCompareCard';
import { tacosPercent, type OrganicPaidBuckets } from '@/api/snapshotMetrics';

export function SnapshotRoasCard({
  currentBuckets,
  previousBuckets,
  currentAcos,
  previousAcos,
  compareEnabled,
  currentTaosSpend = null,
  previousTaosSpend = null,
}: {
  currentBuckets: OrganicPaidBuckets;
  previousBuckets: OrganicPaidBuckets;
  currentAcos: number;
  previousAcos: number;
  compareEnabled: boolean;
  currentTaosSpend?: number | null;
  previousTaosSpend?: number | null;
}) {
  return (
    <SnapshotBarCompareCard
      title="TACOS/ACOS"
      mode="tacosAcos"
      currentBuckets={currentBuckets}
      previousBuckets={previousBuckets}
      currentTotal={tacosPercent(currentTaosSpend, currentBuckets)}
      previousTotal={tacosPercent(previousTaosSpend, previousBuckets)}
      currentAcos={currentAcos}
      previousAcos={previousAcos}
      compareEnabled={compareEnabled}
    />
  );
}
